// UP-1 — direct document upload into the GI-1 Invoice Inbox; extraction/review reuse the existing pipeline unchanged.
import { supabase } from '@/lib/supabase';
import { reExtract } from '@/lib/inbox/service';
import { sha256 } from '@/lib/portal/service';

const q = async (p) => { const { data, error } = await p; if (error) throw error; return data; };
const ACCEPT = { 'application/pdf': 'pdf', 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/heic': 'heic', 'image/heif': 'heif' };
const MAX = 20 * 1024 * 1024;

export const mimeOf = (file) => file.type || (/\.pdf$/i.test(file.name) ? 'application/pdf' : /\.(jpe?g)$/i.test(file.name) ? 'image/jpeg' : /\.png$/i.test(file.name) ? 'image/png' : /\.heic$/i.test(file.name) ? 'image/heic' : '');

// Returns { importId, existing, extracted } — never creates a supplier invoice.
export async function uploadInvoiceDocument(organisationId, file, onStep) {
  const mime = mimeOf(file);
  if (!ACCEPT[mime]) throw new Error('Unsupported file — upload a PDF or a photo (JPEG, PNG, WEBP, HEIC).');
  if (!file.size) throw new Error('The file is empty.');
  if (file.size > MAX) throw new Error('The file is larger than 20 MB — reduce the photo size or split the PDF.');
  onStep?.('Checking document…'); const sha = await sha256(file);
  const path = `${organisationId}/upload/${Date.now()}-${file.name.replace(/[^\w.\-]+/g, '_')}`;
  onStep?.('Uploading…');
  const up = await supabase.storage.from('invoice-docs').upload(path, file, { contentType: mime, upsert: false });
  if (up.error) throw new Error(`Upload failed: ${up.error.message}`);
  let reg;
  try { reg = (await q(supabase.rpc('gi1_register_upload', { _org: organisationId, _file_name: file.name, _mime: mime, _size: file.size, _sha256: sha, _storage_path: path })))?.[0]; }
  catch (e) { await supabase.storage.from('invoice-docs').remove([path]).catch(() => {}); throw e; }
  if (!reg) throw new Error('The document could not be registered in the Inbox.');
  if (reg.existing) { await supabase.storage.from('invoice-docs').remove([path]).catch(() => {}); return { importId: reg.import_id, existing: true, state: reg.state, extracted: null }; }
  onStep?.('Reading document…');
  let extracted = false;
  try { const r = await reExtract(organisationId, reg.import_id); extracted = !!r?.ok; } catch { extracted = false; }
  return { importId: reg.import_id, existing: false, state: 'new', extracted };
}
